export default "__VITE_ASSET__Ca37hiL___"